import { render, staticRenderFns } from "./totpRegister.vue?vue&type=template&id=39cd28a6&"
import script from "./totpRegister.vue?vue&type=script&lang=js&"
export * from "./totpRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports